module.exports = __webpack_public_path__ + "media/images/admin/icons/cloud-lightning-df5a952f89efd59413edbf0a125183fe.svg";